import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Container, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, NavDropdown, UncontrolledDropdown, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, ButtonDropdown, Button, Badge } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import io from 'socket.io-client';

import config from '../../../../config';

import { capitalizeFirstLetter } from '../../../../util/text';

import { initSocket, initPersistedData, initApp } from '../../AppActions';
import { getMainProduct, getProductSlugPath } from '../../../Product/ProductActions';
import { getCartItemsCount } from '../../../Cart/CartActions';
import { initLanguage, getCountryFromLanguage, getLanguagePath } from '../../../Intl/IntlActions';
import { getLoggedUser, setUserPreferenceRequest, logoutUser, getUserPreference } from '../../../User/UserActions';
import { displayErrors, removeError } from '../../../Error/ErrorActions';
import socketListener from '../../../../socketListener';

import { enabledLanguages } from '../../../../../Intl/setup';

// import Flag from '../../../../components/Flag/Flag';
import FontCustom from '../../../../components/Content/FontCustom';

import AppLogo from '../AppLogo';
import AdminMenu from '../menu/AdminMenu';
import CmsPanel from '../../../Cms/components/content/CmsPanel';
// import UserProfileImage from '../../../User/components/profile/UserProfileImage';

const socket = io(config.ws);


class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            dropdownLanguageOpen: false,
            dropdownProfileOpen: false,
            isAdminMenuOpen: false,
        };

        this.appVersionInterval = null;

        this.scrollThreshold = 30;

        this.handleScroll = this.handleScroll.bind(this);

        this.toggle = this.toggle.bind(this);
        this.toggleDropdownLanguage = this.toggleDropdownLanguage.bind(this);
        this.toggleDropdownProfile = this.toggleDropdownProfile.bind(this);
        this.toggleAdminMenu = this.toggleAdminMenu.bind(this);

        this.switchLanguage = this.switchLanguage.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(initPersistedData());
        this.props.dispatch(initSocket(socket));
        this.props.user && socketListener(socket, this.props.dispatch, this.props.user, this.props.intl);

        // this.switchLanguage(this.props.match.params.lang);

        /* (this.props.user || !this.props.isMounted) && */this.props.dispatch(initApp());

        // this.props.dispatch(checkVersionRequest());
        // this.appVersionInterval = setInterval(() => {
        //     this.props.dispatch(checkVersionRequest());
        // }, 12 * 60 * 60 * 1000); // 12h

        if(this.props.appRedirect) {
            this.props.history.push(this.props.appRedirect);
        }

        if(window && window.location && !config.url.includes(window.location.origin)) {
            // console.log(window.location.origin, config.url);
            window.location.href = `${config.url}${window.location.pathname.slice(1)}${window.location.search}`;
        }

        window && window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
            this.toggle(false);
        }

        // Update app language from user preferences
        if(!prevProps.user && this.props.user) {
            // getUserPreference(this.props.user, 'language') !== this.props.intl.locale && this.switchLanguage(getUserPreference(this.props.user, 'language'));
            socketListener(socket, this.props.dispatch, this.props.user, this.props.intl);
            if(this.props.user.role === 'admin') {
                this.toggleAdminMenu(true);
            }
        }

        // Redirect app if triggered by other component
        if(prevProps.appRedirect !== this.props.appRedirect) {
            this.props.history.push(this.props.appRedirect);
        }

        // Display or remove errors
        if(prevProps.errors.length !== this.props.errors.length) {
            this.props.errors.forEach(error => {
                if(error && error.type && error.message) {
                    displayErrors(error.type, this.props.intl.messages[`alert${error.message}`] || error.message);
                }
                this.props.dispatch(removeError(error.message));
            });
        }
    }

    componentWillUnmount() {
        window && window.removeEventListener('scroll', this.handleScroll);
    }

    isLoggedIn() {
        return this.props.user && this.props.user._id;
    }

    switchLanguage(lang) {
        (this.props.user ? this.props.dispatch(setUserPreferenceRequest('language', lang, true)) : Promise.resolve()).then(() => {
        // this.props.dispatch(initLanguage(lang, this.props.user)).then(lang => {
            // Search for meta alternate link set by Helmet to redirect to translated content
            const redirectionLink = Array.from(document.querySelectorAll('link[rel="alternate"]')).find(link => link.hreflang === lang);
            if(redirectionLink) {
                console.log('Link alternate found', `/${redirectionLink.href.replace(config.url, '')}`);
                this.props.history.push(`/${redirectionLink.href.replace(config.url, '')}`);
            } else {
                console.log('Replace route to ', getLanguagePath(this.props.location.pathname, lang) + this.props.location.search);
                this.props.history.replace(getLanguagePath(this.props.location.pathname, lang) + this.props.location.search);
            }
        });
        // this.props.history.push(`/${lang}/`);
        // Update user preference
    }

    handleScroll(event) {
        const isScrolling = (document.body.scrollTop || document.documentElement.scrollTop) > this.scrollThreshold;
        if(isScrolling !== this.state.isScrolling) {
            this.setState({
                isScrolling,
            });
        }
    }

    handleLogout() {
        console.log('Logout');
        this.props.dispatch(logoutUser(true));
        this.props.history.push('/');
    }

    toggle(forceValue = null) {
        this.setState({
            isOpen: forceValue !== null && typeof forceValue === 'boolean' ? forceValue : !this.state.isOpen,
        });
    }

    toggleAdminMenu(force = null) {
        this.setState({
            isAdminMenuOpen: force !== null ? force : !this.state.isAdminMenuOpen,
        });
    }

    toggleDropdownLanguage() {
        this.setState({
            dropdownLanguageOpen: !this.state.dropdownLanguageOpen,
        });
    }

    toggleDropdownProfile() {
        this.setState({
            dropdownProfileOpen: !this.state.dropdownProfileOpen,
        });
    }

    renderLanguages(isDropdown = false) {
        // <Flag country={getCountryFromLanguage(lang)} />
        // <Flag country={getCountryFromLanguage(this.props.intl.locale)} />

        if(isDropdown) {
            const languages = enabledLanguages.filter(locale => locale !== this.props.intl.locale);
            return (
                <ButtonDropdown isOpen={this.state.dropdownLanguageOpen} toggle={event => this.toggleDropdownLanguage()}>
                    <DropdownToggle nav caret className="p-0">
                        {capitalizeFirstLetter(this.props.intl.locale)}
                    </DropdownToggle>
                    <DropdownMenu className="text-center" style={{ minWidth: 'auto' }}>
                        {languages.map(lang => (
                            <DropdownItem key={lang} size="sm" onClick={() => this.switchLanguage(lang)}>
                                <span className={lang === this.props.intl.locale ? 'selected' : ''}>
                                    {capitalizeFirstLetter(lang)}
                                </span>
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        }
        return (
            <ul className="mt-2 mb-0 list-inline text-dark">
                {enabledLanguages.map((lang, index) => (
                    <li key={lang} className={classnames('list-inline-item', 'pr-2', index + 1 !== enabledLanguages.length && ['border-right', 'border-primary'], this.props.intl.locale === lang && 'text-white')} onClick={() => this.switchLanguage(lang)}>
                        {this.props.intl.locale === lang ? <strong>{capitalizeFirstLetter(lang)}</strong> : capitalizeFirstLetter(lang)}
                    </li>
                ))}
            </ul>
        );
    }

    renderCustomerAccountLink(isScrolledItem = false, isMobile = false) {
        // <ButtonDropdown isOpen={this.state.dropdownProfileOpen} toggle={event => this.toggleDropdownProfile()}>
        //     <DropdownToggle caret nav className="p-0">
        //         <FontAwesome name="user-circle" fixedWidth /> {!isScrolledItem && <span className="ml-1 d-none d-md-inline">{this.props.user ? `${this.props.user.firstName} ${this.props.user.lastName}` : null}</span>}
        //     </DropdownToggle>
        //     <DropdownMenu className="text-center text-info">
        //         <DropdownItem tag={Link} to={getLanguagePath('/user/profile', this.props.intl.locale)} className="d-block">
        //             <FontAwesome name="user-circle" fixedWidth /> <FormattedMessage id="userAccountMy" defaultMessage="My account" />
        //         </DropdownItem>
        //         <div className="dropdown-divider" />
        //         <DropdownItem tag={Button} color="light" size="sm" onClick={() => this.handleLogout()}>
        //             <FontAwesome name="power-off" fixedWidth /><FormattedMessage id="userLogout" defaultMessage="Log out" />
        //         </DropdownItem>
        //     </DropdownMenu>
        // </ButtonDropdown>
        return (
            <NavItem>
                {
                    this.isLoggedIn()
                    ? <Link to={getLanguagePath('/user/profile', this.props.intl.locale)}><FontCustom name="user" size={isMobile && 2} className={classnames(isMobile && 'text-white')} /> {!isScrolledItem && <FormattedMessage id="userAccountMy" defaultMessage="My account" />}</Link>
                    : <Link to={getLanguagePath('/user/login', this.props.intl.locale)}><FontCustom name="user" size={isMobile && 2} className={classnames(isMobile && 'text-white')} /> {!isScrolledItem && <FormattedMessage id="userCustomerAccountLink" defaultMessage="Customer account" />}</Link>
                }

            </NavItem>
        );
    }

    renderGeneralMenu(isMobile = false) {
        return <CmsPanel slug="main-menu" isTemplate isMobile={isMobile} />;
    }

    renderInfoMenu(isMobile = false) {
        const phoneItem = (
            <NavItem>
                <a href={`tel:${config.application.phone}`}><strong><FontCustom name="contact" size={2} className={classnames(isMobile && 'text-white')} /> {config.application.phone}</strong></a>
            </NavItem>
        );
        const itemsInCart = 3;
        return (
            <Nav className={classnames(!isMobile && ['d-flex', 'justify-content-md-end'], 'info-menu', isMobile && ['mt-4', 'mobile'])}>
                {!isMobile && phoneItem}
                {this.renderCustomerAccountLink(false, isMobile)}
                <NavItem>
                    <Link to={getLanguagePath('/cart', this.props.intl.locale)}>
                        <FontCustom name="basket" size={isMobile && 2} className={classnames(isMobile && 'text-white')} />{' '}
                        <FormattedMessage id="orderCartLink" defaultMessage="Cart" />
                        {
                            this.props.cartItemsCount > 0
                            ? <Fragment>{' '}<small>{isMobile ? <span className="text-white">({this.props.cartItemsCount})</span> : <Badge color="warning" pill>{this.props.cartItemsCount}</Badge>}</small></Fragment>
                            : null
                        }
                    </Link>
                </NavItem>
                {
                    isMobile
                    ? phoneItem
                    : <NavItem>
                            {this.renderLanguages(true)}
                      </NavItem>
                }
            </Nav>
        );
    }

    render() {
        return (
            <div className={classnames('fixed-top', 'header-wrapper', this.state.isOpen ? 'bg-secondary' : 'bg-white', this.state.isScrolling && 'header-scrolled')}>
                <Container fluid="xl" className="p-0">
                    <Navbar light expand="md" className="px-4 px-sm-3">
                        <NavbarBrand tag={Link} to={getLanguagePath('/', this.props.intl.locale)}>
                            <span className={classnames(this.state.isOpen && 'd-none', 'd-md-block', 'logo')}><AppLogo /></span>
                            <span className={classnames(this.state.isOpen ? 'd-block' : 'd-none', 'd-md-none', 'logo')}><AppLogo suffix="alt" /></span>
                            <span className="d-none d-md-block text-primary pt-1 baseline"><CmsPanel slug="app-baseline" isTemplate /></span>
                        </NavbarBrand>
                        <NavbarToggler onClick={this.toggle} tag="span" className="border-0 text-dark" style={{ position: 'absolute', top: '0.5rem', right: '-0.5rem' }}>
                            <FontCustom name={this.state.isOpen ? 'close' : 'burger'} className={classnames(this.state.isOpen && 'text-white')} size={4} />
                        </NavbarToggler>

                        <div className="d-none d-md-block ml-0 ml-md-auto w-100 text-dark">
                            <div className="top-bar">
                                {this.renderInfoMenu()}
                            </div>

                            <div className="bottom-bar d-flex justify-content-end">
                                {
                                    this.isLoggedIn() && this.props.user.role === 'admin' && this.state.isAdminMenuOpen
                                    ? (
                                        <AdminMenu />
                                    )
                                    : (
                                        <Fragment>
                                            {this.renderGeneralMenu()}

                                            <div className="scrolled-items">
                                                <Nav>
                                                    {this.renderCustomerAccountLink(true)}
                                                    <NavItem>
                                                        <Link to={getLanguagePath('/cart', this.props.intl.locale)}><FontCustom name="basket" /><small>{this.props.cartItemsCount > 0 ? <Badge color="secondary" pill>{this.props.cartItemsCount}</Badge> : null}</small></Link>
                                                    </NavItem>
                                                </Nav>
                                            </div>
                                            <CmsPanel slug="cta-menu" isTemplate isScrolling={this.state.isScrolling} />
                                        </Fragment>
                                    )
                                }
                                {
                                    this.isLoggedIn() && this.props.user.role === 'admin'
                                    ? <Button color={this.state.isAdminMenuOpen ? '' : 'link'} size={this.state.isScrolling ? 'sm' : ''} className="ml-2 p-0" onClick={() => this.toggleAdminMenu()} style={{ position: 'absolute', right: '-15px' }}>{this.state.isAdminMenuOpen ? <FontAwesome name="times" /> : <FontAwesome name="cogs" />}</Button>
                                    : null
                                }
                            </div>
                        </div>

                        <Collapse isOpen={this.state.isOpen} navbar>
                            <div className="d-block d-md-none collapsed-menu">
                                {this.renderLanguages()}

                                {
                                    this.isLoggedIn() && this.props.user.role === 'admin' && this.state.isAdminMenuOpen
                                    ? <AdminMenu />
                                    : this.renderGeneralMenu(true)
                                }

                                {this.renderInfoMenu(true)}
                            </div>
                        </Collapse>
                    </Navbar>
                </Container>
            </div>
        );
    }
}
// <FormattedMessage id="accountMy" defaultMessage="My account" /> ({`${this.props.user.firstName} ${this.props.user.lastName}`})

function mapStateToProps(store, props) {
    return {
        errors: store.error.data,
        user: getLoggedUser(store),
        appRedirect: store.app.redirect,
        product: getMainProduct(store),
        cartItemsCount: getCartItemsCount(store),
        isMounted: store.app.isMounted,
    };
}

Header.defaultProps = {
    user: null,
    appRedirect: '',
    product: null,
    cartItemsCount: 0,
};

Header.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    errors: PropTypes.arrayOf(PropTypes.object).isRequired,
    user: PropTypes.object,
    appRedirect: PropTypes.string,
    product: PropTypes.object,
    cartItemsCount: PropTypes.number,
    isMounted: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(withRouter(injectIntl(Header)));
